import Icon from '@atoms/Icon/Icon';
import Text from '@atoms/Text/Text';
import { IIconCard } from '@models/IIconCard';
import classNames from 'classnames';

const IconCard = ({ icon, title, subText }: IIconCard) => (
  <div className="tw-h-full tw-bg-white tw-px-4 tw-py-6 tw-text-black">
    <Icon name={icon} className="tw-mb-6" size="4rem" />

    <Text
      variant="heading-28"
      as="p"
      className={classNames({ 'tw-mb-6': !!subText })}
    >
      {title}
    </Text>

    {subText && (
      <Text variant="body" className="tw-text-grey-80">
        {subText}
      </Text>
    )}
  </div>
);

export default IconCard;
